import React from 'react'

export const select = ({ input, label, meta: { touched, error }, disabled, prependOptionLabel, prependOptionValue, options, t, required = false, settingsName }) => (
	<div className={'form-group ' + (touched && error ? 'is-invalid' : '')}>
		<label htmlFor={input.name}>
			{label} {required && <span className="mandatory">*</span> }
		</label>

		<select
			disabled={disabled === true}
			id={input.name} {...input}
			className={'c-select form-control ' + (touched && error ? 'is-invalid' : '')}>

			{
				prependOptionLabel !== undefined &&
				(
					<option value={prependOptionValue}>{prependOptionLabel}</option>
				)
			}

			{Object.keys(options).map(option => {
				return (
					<option key={option}
					        value={option}>{t(`settings.${settingsName}.${option}`)}</option>
				)
			})}
		</select>

		{touched && error && <p className="text-danger"><span>{error}</span></p>}
	</div>
)
